<!--
 * @Author: zyy
 * @Date: 2023-07-18 14:12:55
 * @LastEditTime: 2023-07-18 14:55:13
 * @FilePath: /tjzhsq-admin-dnk/src/views/platform/complaint/modules/assign.vue
 * @Description: yahu~
 * 
-->
<template>
    <div>
        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
            destroy-on-close centered>
            <a-form-model ref="form" :model="modal.subData" layout="vertical" :rules="modal.rules">
                <a-form-model-item label="分配人员" prop='staff_id'>
                    <a-select placeholder="请选择指派人" v-model="modal.subData.staff_id">
                        <a-select-option :value="value.id" v-for="value in modal.initData.staffOptions" :key="value.id">{{
                            value.name }}</a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import complaintListService from "@/io/complaint/complaintList.js";
import CommunityService from "@/io/community.js";

export default {
    emits: ['submit'],
    data() {
        return {
            modal: {
                title: '分配人员',
                show: false,
                loading: false,
                // 0新增，1编辑
                type: 0,
                subData: {
                    staff_id: []
                },
                rules: {
                    staff_id: [
                        {
                            required: true,
                            message: "请选择分配人员",
                        }
                    ],
                },
                initData: {
                    staffOptions: []
                }
            },
            info: {}

        }
    },
    methods: {
        open(data) {
            this.modal.show = true
            this.info = data
            this.initDetailData(data)
        },
        //   初始化页面数据
        async initDetailData(data) {
            const staffRes = await CommunityService.staff(data.community?.id)
            this.modal.initData.staffOptions = staffRes;
        },
        // 提交
        confirmModal() {
            this.$beforeFormSubmit(this.$refs.form, async () => {
                const res = await complaintListService.assign({
                    id: this.info.id,
                    staff_id: this.modal.subData.staff_id
                })
                this.$afterFormSubmit("修改成功", () => {
                    this.modal.show = false
                    this.modal.loading = false
                    this.$emit('submit')
                });
            });
        },
    }
}

</script>

<style scoped lang="scss"></style>
